import {PaginationList} from '../../../../shared/models/product/product-list/pagination-list';
import {Transaction} from './transaction';
import {Type} from 'class-transformer';
import {decoratorType} from 'lib-shared';

export class TransactionList extends PaginationList<Transaction> {
  @Type(decoratorType(Transaction))
  results: Transaction[];
}
